import examinationSaga from './examination-saga';

export default examinationSaga;
